import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import {environment} from '../environments/environment';

import { MatDialogModule,
MatTooltipModule,
MatSelectModule,
MatMenuModule,
MatProgressSpinnerModule,
MatSliderModule,
MatCheckboxModule,
MatExpansionModule,
MatInputModule,
MatStepperModule } from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { AgmCoreModule } from '@agm/core';

import { AppRoutingModule } from './app.routes';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { ViewMenuComponent } from './view-menu/view-menu.component';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ViewLoginComponent } from './view-login/view-login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { ViewNotificationComponent } from './view-notification/view-notification.component';
import { SearchFreelancersComponent } from './search-freelancers/search-freelancers.component';
import { ListFreelancersComponent } from './list-freelancers/list-freelancers.component';
import { ListQaComponent } from './list-qa/list-qa.component';
import { ListQaDashboardComponent } from './list-qa-dashboard/list-qa-dashboard.component';
import { ListReqComponent } from './list-req/list-req.component';
import { ListReqNoFreelancerComponent } from './list-req-no-freelancer/list-req-no-freelancer.component';
import { ListContractNewComponent } from './list-contract-new/list-contract-new.component';
import { SliderCvComponent } from './slider-cv/slider-cv.component';
import { CreateRequisitionComponent } from './create-requisition/create-requisition.component';
import { ListRequisitionComponent } from './list-requisition/list-requisition.component';
import { ViewRequisitionComponent } from './view-requisition/view-requisition.component';
import { ViewDossierDialogComponent } from './view-dossier-dialog/view-dossier-dialog.component';
import { CvComponent } from './cv/cv.component';
import { FormRequisitionComponent } from './form-requisition/form-requisition.component';
import { FormJobComponent } from './form-job/form-job.component';
import { FormQaComponent } from './form-qa/form-qa.component';
import { ItemCandidateComponent } from './item-candidate/item-candidate.component';
import { ViewCvComponent } from './view-cv/view-cv.component';

import { MessageBoxInviteDialog } from './message-box-invite/message-box-invite.component';

import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { HttpAuth } from './services/http-auth.service';
import { ConfigurationService } from './services/configuration.service';
import { NotificationService } from './services/notification.service';
import { JobTypeService } from './services/jobtype.service';
import { RecoverPasswordService } from './services/recover-password.service';
import { InviteService } from './services/invite.service';
import { FreelancerService } from './services/freelancer.service';
import { ListFreelancersService } from './services/list-freelancers.service';
import { RequisitionService } from './services/requisition.service';
import { FullProfileService } from './services/full-profile.service';
import { JobOffersService } from './services/job-offers.service';
import { ReportService } from './services/report.service';
import { EnterpriseService } from './services/enterprise.service';

import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { MessageBoxDialog } from './message-box/message-box.component';
import { FreelancerStore } from './state/freelancer.store';
import { importExpr } from '@angular/compiler/src/output/output_ast';

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ViewLoginComponent,
    MessageBoxDialog,
    MenuComponent,
    ViewMenuComponent,
    DashboardComponent,
    RecoveryPasswordComponent,
    ViewNotificationComponent,
    SearchFreelancersComponent,
    ListFreelancersComponent,
    ListQaComponent,
    ListQaDashboardComponent,
    ListReqComponent,
    ListReqNoFreelancerComponent,
    ListContractNewComponent,
    SliderCvComponent,
    CreateRequisitionComponent,
    ListRequisitionComponent,
    ViewRequisitionComponent,
    ViewDossierDialogComponent,
    CvComponent,
    FormRequisitionComponent,
    FormJobComponent,
    FormQaComponent,
    ItemCandidateComponent,
    ViewCvComponent,
    MessageBoxInviteDialog
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTooltipModule,
    MatSelectModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatStepperModule,
    Ng2DeviceDetectorModule.forRoot(),
    NgbModule.forRoot(),
    NgxPaginationModule,
    AgmCoreModule.forRoot({
      apiKey: environment.apiGoogleKey,
      libraries: ['places']
    }),
  ],
  entryComponents: [
    MessageBoxDialog,
    SliderCvComponent,
    ViewDossierDialogComponent,
    CvComponent,
    ViewCvComponent,
    MessageBoxInviteDialog
  ],
  providers: [
    AuthService,
    AuthGuardService,
    HttpAuth,
    ConfigurationService,
    NotificationService,
    JobTypeService,
    RecoverPasswordService,
    InviteService,
    FreelancerStore,
    ListFreelancersService,
    FreelancerService,
    RequisitionService,
    FullProfileService,
    JobOffersService,
    ReportService,
    EnterpriseService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/app.module.ts